angular.module('gym.pos').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.pos.reconciliations', {
    url: '/reconciliations',
    template: require('templates/gyms/pos/reconciliations/reconciliations.html.slim')
  });
}]);
